export const ipMoodle = "138.68.226.91";
export const baseURL = "https://elearning.inatrans.cl/";
// export const tipddytoken = "122c8d73318e7ae3c25261962bea48c1";
// export const tipddytoken = "6efdf3eb77bc8beca386c774fab608aa";
//export const tipddytoken = "4f7ded3dd876db415ad9e11406e8e78b"; // tuclase
//export const tipddytoken = "3018509e690718153672c6a2be50aa70"//"c905f06a8f3cd6b5e64a70ec0e7e75da"; // esta estpa generado a nombre de agu quiroz
//export const tipddytoken = "2db2e5370e793d7ca93ad5002c5b14b2"
export const tipddytoken = "5c038704f5a3a91f4ab3f336f66de581"

export const moodleURL = `${baseURL}webservice/rest/server.php?wstoken=`;
export const iappUrl = "https://tipddy-rnu.iapp.cl/api/rnu";

export const API = {
  dev: "http://localhost:3000/",
  prod: "https://alumnos.tuclase.cl",
};
